import React from "react";
import "./RetailMore.css"; // Import this CSS file

export default function RetailMore() {
  const sections = [
    {
      title: "1. Predictive Demand Forecasting",
      description:
        "OrbiNexum’s advanced predictive analytics models allow retailers and supply chain managers to:",
      points: [
        "Accurately forecast demand based on historical data, seasonal trends, and external factors (like weather or economic changes).",
        "Minimize stockouts and overstock situations by optimizing inventory levels.",
        "Increase sales by aligning product availability with customer demand, avoiding missed opportunities during peak seasons.",
      ],
      result:
        "By using predictive analytics, companies can reduce waste and improve stock turn rates, ensuring they never run out of popular products or overstock low-demand items.",
    },
    {
      title: "2. AI-Driven Customer Behavior Analysis",
      description:
        "OrbiNexum’s AI models analyze customer purchase patterns, social media sentiment, and even online browsing habits to give businesses a deeper understanding of what customers truly want. Benefits include:",
      points: [
        "Personalized Marketing: Craft targeted campaigns that resonate with different customer segments, increasing conversion rates.",
        "Customer Retention: Understand what drives customer loyalty and satisfaction, and enhance engagement.",
        "Product Recommendations: Improve cross-selling and up-selling by suggesting relevant products in real-time based on individual behavior.",
      ],
      result:
        "This ensures a tailored experience, boosting brand loyalty and repeat purchases.",
    },
    {
      title: "3. Supply Chain Optimization for Time & Cost Savings",
      description:
        "OrbiNexum’s data analytics streamline your supply chain by identifying inefficiencies, delays, or bottlenecks. Key benefits:",
      points: [
        "Optimized Routes: Minimize logistics costs and reduce delivery times with real-time tracking and route optimization.",
        "Supplier Risk Management: Identify potential disruptions in the supply chain (e.g., vendor delays, geopolitical risks) and proactively manage supplier relationships.",
        "Inventory Optimization: Automate reorder processes based on predicted demand to avoid understocking or overstocking, ensuring leaner operations and higher margins.",
      ],
      result:
        "With supply chain optimization, companies can not only reduce operational costs but also improve service levels, ensuring timely product delivery to customers.",
    },
  ];

  return (
    <div className="retail-section" id="Retail">
      <h1 className="retail-title">
        Retail & Supply Chain: Unleashing Efficiency and Personalization
      </h1>
      <p className="retail-subtitle">
        In the fast-paced world of retail and supply chain management, OrbiNexum
        provides the tools to turn real-time data into strategic decisions that
        drive growth. Here’s how OrbiNexum helps:
      </p>

      <div className="retail-grid">
        {sections.slice(0, 2).map((section, index) => (
          <div key={index} className="retail-block">
            <h2 className="retail-heading">{section.title}</h2>
            <p className="retail-description">{section.description}</p>
            <ul className="retail-list">
              {section.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
            <p className="retail-result">{section.result}</p>
          </div>
        ))}
      </div>

      <div className="retail-center">
        <div className="retail-block">
          <h2 className="retail-heading">{sections[2].title}</h2>
          <p className="retail-description">{sections[2].description}</p>
          <ul className="retail-list">
            {sections[2].points.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
          <p className="retail-result">{sections[2].result}</p>
        </div>
      </div>
    </div>
  );
}
